import {
    GET_TABLE_RESERVATION_LIST_REQUEST, GET_TABLE_RESERVATION_LIST_SUCCESS, GET_TABLE_RESERVATION_LIST_FAILURE,
    POST_TABLE_RESERVATION_LIST_REQUEST, POST_TABLE_RESERVATION_LIST_SUCCESS, POST_TABLE_RESERVATION_LIST_FAILURE,
    GET_BYID_TABLE_RESERVATION_LIST_REQUEST, GET_BYID_TABLE_RESERVATION_LIST_SUCCESS, GET_BYID_TABLE_RESERVATION_LIST_FAILURE,
    PUT_TABLE_RESERVATION_LIST_REQUEST, PUT_TABLE_RESERVATION_LIST_SUCCESS, PUT_TABLE_RESERVATION_LIST_FAILURE,
    DELETE_TABLE_RESERVATION_LIST_REQUEST, DELETE_TABLE_RESERVATION_LIST_SUCCESS, DELETE_TABLE_RESERVATION_LIST_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
     tableReservationList: {},
     addTableReservation: {},
     tableReservationById: {},
    loading: false,
    error: null,
};

export const ReservationTableReducer = (state = initialState, action) => {
    switch (action.type) {
        // GET amenity
        case GET_TABLE_RESERVATION_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_TABLE_RESERVATION_LIST_SUCCESS:
            return {
                ...state,
                 tableReservationList: action.payload,
                loading: false,
                error: null,
            };
        case GET_TABLE_RESERVATION_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // POST amenity
        case POST_TABLE_RESERVATION_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case POST_TABLE_RESERVATION_LIST_SUCCESS:
            return {
                ...state,
                 addTableReservation: action.payload,
                loading: false,
                error: null,
            };
        case POST_TABLE_RESERVATION_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // DELETE amenity
        case DELETE_TABLE_RESERVATION_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case DELETE_TABLE_RESERVATION_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            };
        case DELETE_TABLE_RESERVATION_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case PUT_TABLE_RESERVATION_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case PUT_TABLE_RESERVATION_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            };
        case PUT_TABLE_RESERVATION_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case GET_BYID_TABLE_RESERVATION_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_BYID_TABLE_RESERVATION_LIST_SUCCESS:
            return {
                ...state,
                 tableReservationById: action.payload,
                loading: false,
                error: null,
            };
        case GET_BYID_TABLE_RESERVATION_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};
